import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Button, Form } from 'react-bootstrap';

import { useProfileUpdate } from '../../../hooks';
import { Divider } from '../../BaseUI';
import { TextField } from '../../FormFields';
import SocialSchema from './SocialSchema';

const removeSpaces = (string) => string.replace(/\s/g, '');

const Profile = ({ userId, twitter, linkedin, instagram, personalUrl, isDisabled }) => {
  const initialState = useMemo(
    () => ({
      twitter: twitter || '',
      linkedin: linkedin || '',
      instagram: instagram || '',
      personalUrl: personalUrl || '',
    }),
    [twitter, linkedin, instagram, personalUrl]
  );
  const { saveProfile, isSavingProfile, showSave } = useProfileUpdate(userId);

  const handleSubmit = (values) => {
    const sanitizedParams = {
      twitter: removeSpaces(values.twitter),
      linkedin: removeSpaces(values.linkedin),
      instagram: removeSpaces(values.instagram),
      personal_url: removeSpaces(values.personalUrl),
    };

    saveProfile(sanitizedParams);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialState}
      onSubmit={handleSubmit}
      validationSchema={SocialSchema}
    >
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <div className="section-container" id="Social">
            <div className="section-header mt-2">Social</div>
            <div className="section-detail">
              <div className="section-detail-container">
                <div className="section-description">
                  <div>Where can we find you online?</div>
                </div>
              </div>
              <div className="section-form-container">
                <TextField
                  name="personalUrl"
                  label="Website"
                  placeholder="https://"
                  disabled={isDisabled}
                />
                <TextField
                  name="linkedin"
                  label="LinkedIn"
                  preset="@"
                  placeholder="handle"
                  disabled={isDisabled}
                />
                <TextField
                  name="twitter"
                  label="Twitter"
                  preset="@"
                  placeholder="handle"
                  disabled={isDisabled}
                />
                <TextField
                  name="instagram"
                  label="Instagram"
                  preset="@"
                  placeholder="handle"
                  disabled={isDisabled}
                />
              </div>
            </div>
            <div className="save-action-container" id="social-save">
              <Button
                className="profile-button --red --small-width"
                type="submit"
                disabled={!(formik.isValid && formik.dirty) || isDisabled || isSavingProfile}
              >
                {showSave ? 'Saved' : 'Save'}
              </Button>
            </div>
            <Divider />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Profile;
